import styled from "@emotion/styled";
import {
  OLD_BLUE,
  BLUE_LIGHT,
  BACKGROUND_LIGHT,
  PRIMARY_GREY,
  TERTIARY_GREY,
} from "src/constants/colors";

export const ListMenuItem = styled.div<{
  currentSelection: boolean;
  disabled?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  border-radius: 64px;
  padding: 8px;
  gap: 16px;
  background-color: ${(props) =>
    props.currentSelection ? BLUE_LIGHT : "transparent"};
  cursor: ${(props) =>
    props.disabled
      ? "not-allowed"
      : props.currentSelection
        ? "default"
        : "pointer"};
  transition: background-color 0.3s ease;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};

  &:hover {
    background-color: ${(props) =>
      props.disabled || props.currentSelection ? "none" : PRIMARY_GREY};
  }
`;

export const LeftWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

export const IconWrapper = styled.div<{ currentSelection: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 150px;
  background-color: ${(props) =>
    props.currentSelection ? BACKGROUND_LIGHT : BLUE_LIGHT};
  color: ${OLD_BLUE};
  opacity: ${(props) => (props.currentSelection ? 1 : 0.7)};
  transition: opacity 0.3s ease;
  background-color 0.3s ease;
`;

export const ListDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.span`
  font-size: 16px;
  leading-trim: Cap height;
  line-height: 100%;
  letter-spacing: -0.6%;
`;

export const SubLabel = styled.span`
  font-size: 12px;
  leading-trim: Cap height;
  line-height: 100%;
  letter-spacing: -0.6%;
  color: ${TERTIARY_GREY};
`;

export const ChevronWrapper = styled.div<{ currentSelection: boolean }>`
  opacity: ${(props) => (props.currentSelection ? 0 : 0.7)};
  transition: opacity 0.3s ease;
  display: flex;
  align-items: center;
`;
